import styled from "styled-components"
import { maxWidth } from "utils"

export const Container = styled.div`
  color: ${(props) => props.theme.component.text};

  h2 {
    font-size: 3.6rem;
    line-height: 4.2rem;

    ${maxWidth.mobile`
      font-size: 3rem;
      line-height: 1.4em;
    `}
  }

  h3 {
    font-size: 3rem;
    font-weight: 400;
    margin: 0.8rem 0;

    ${maxWidth.mobile`
      font-size: 2.1rem;
    `}
  }

  h4 {
    text-transform: uppercase;
    margin: 1.5rem 0;
    color: gray;
  }

  p {
    font-size: 1.8rem;
    line-height: 2.4rem;
  }

  ul {
    margin: 0;
    padding: 0;
    margin-left: 1.8rem;
  }

  li {
    padding-bottom: 1.4rem;
  }
`
